// extracted by mini-css-extract-plugin
module.exports = {"timer":"_3554","item":"_11438","divider":"_17474"};